import { useEffect, useState } from 'react';
import { useReducedMotion } from '../motion';
import draftGrades from '../data/draftGrades.json';
import RegistrarHero from '../components/grades/RegistrarHero';
import RegistrarCountdown from '../components/grades/RegistrarCountdown';
import RegistrarLedger from '../components/grades/RegistrarLedger';
import RegistrarExhibits from '../components/grades/RegistrarExhibits';
import RegistrarBoard from '../components/grades/RegistrarBoard';
import RegistrarReceipts from '../components/grades/RegistrarReceipts';
import { REGISTRAR_COPY } from '../components/grades/registrarCopy';
import '../components/grades/registrar.css';

export default function DraftGrades() {
  const reduced = useReducedMotion();
  const [disputeHidden, setDisputeHidden] = useState(false);
  const standings = [...draftGrades.teams].sort((a, b) => a.rank - b.rank);
  const countdown = [...standings].reverse();
  const roundCount = Math.max(...draftGrades.picks.map((pick) => pick.round));

  useEffect(() => {
    if (!window.matchMedia || typeof IntersectionObserver === 'undefined') return undefined;
    const mobile = window.matchMedia('(max-width: 900px)');
    const visibility = new Map();
    let observer;
    const disconnect = () => {
      observer?.disconnect();
      observer = undefined;
      visibility.clear();
      setDisputeHidden(false);
    };
    const update = () => {
      disconnect();
      if (!mobile.matches) return;
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting));
        setDisputeHidden([...visibility.values()].some(Boolean));
      }, { threshold: 0 });
      [document.getElementById('registrar-countdown'), document.querySelector('.rg-receipts'), document.querySelector('.rg-seal-wall'), document.getElementById('registrar-ledger')]
        .filter(Boolean)
        .forEach((element) => observer.observe(element));
    };
    update();
    mobile.addEventListener ? mobile.addEventListener('change', update) : mobile.addListener(update);
    return () => {
      observer?.disconnect();
      mobile.removeEventListener ? mobile.removeEventListener('change', update) : mobile.removeListener(update);
    };
  }, []);

  return (
    <div className={`rg ${reduced ? 'rg--static' : ''}`} data-reduced-motion={reduced ? 'true' : 'false'}>
      <RegistrarHero
        season={draftGrades.season}
        teams={standings}
        pickCount={draftGrades.draftedPickCount}
        roundCount={roundCount}
        reduced={reduced}
      />
      <RegistrarCountdown
        teams={countdown}
        copyBySlug={REGISTRAR_COPY}
        weights={draftGrades.methodology.weights}
        reduced={reduced}
      />
      <RegistrarLedger teams={standings} />
      <RegistrarExhibits superlatives={draftGrades.superlatives} teams={standings} />
      <RegistrarBoard picks={draftGrades.picks} teams={standings} />
      <RegistrarReceipts
        methodology={draftGrades.methodology}
        picks={draftGrades.picks}
        teamCount={draftGrades.teams.length}
      />
      <a href="#registrar-receipts" className={`rg-dispute ${disputeHidden ? 'is-hidden' : ''}`}>Dispute a grade</a>
    </div>
  );
}
